import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Panel, Btn, Field, inputCls, SingleImageUploader } from "./AdminUI";
import { toast } from "sonner";

export default function ManageSettings() {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/settings").then((r) => setS(r.data || {})); }, []);
  if (!s) return <div className="text-[#5A6270]">Loading…</div>;

  const set = (section, key, val) => setS({ ...s, [section]: { ...(s[section] || {}), [key]: val } });
  const save = async () => { await api.put("/settings", s); toast.success("Settings saved. Live on the website."); };

  const home = s.home || {}, about = s.about || {}, contact = s.contact || {}, payment = s.payment || {};

  return (
    <div className="space-y-6" data-testid="admin-settings">
      <Panel title="Home & Hero">
        <div className="grid sm:grid-cols-3 gap-3">
          <Field label="Founding Year"><input className={inputCls} value={home.founding_year || ""} onChange={(e) => set("home", "founding_year", e.target.value)} /></Field>
          <Field label="Total Members"><input className={inputCls} value={home.total_advocates || ""} onChange={(e) => set("home", "total_advocates", e.target.value)} /></Field>
          <Field label="Active Committees"><input className={inputCls} value={home.active_committees || ""} onChange={(e) => set("home", "active_committees", e.target.value)} /></Field>
        </div>
        <Field label="Tagline"><input className={inputCls} value={home.tagline || ""} onChange={(e) => set("home", "tagline", e.target.value)} /></Field>
        <Field label="President's Message"><textarea rows={3} className={inputCls} value={home.president_message || ""} onChange={(e) => set("home", "president_message", e.target.value)} /></Field>
      </Panel>

      <Panel title="About Us Content">
        {[["history", "History"], ["mission", "Mission"], ["facilities", "Facilities"], ["welfare", "Welfare"]].map(([k, l]) => (
          <Field key={k} label={l}><textarea rows={3} className={inputCls} value={about[k] || ""} onChange={(e) => set("about", k, e.target.value)} data-testid={`about-${k}`} /></Field>
        ))}
      </Panel>

      <Panel title="Contact Details">
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Association Name"><input className={inputCls} value={contact.name || ""} onChange={(e) => set("contact", "name", e.target.value)} /></Field>
          <Field label="Landline"><input className={inputCls} value={contact.phone || ""} onChange={(e) => set("contact", "phone", e.target.value)} /></Field>
          <Field label="Mobile"><input className={inputCls} value={contact.mobile || ""} onChange={(e) => set("contact", "mobile", e.target.value)} /></Field>
          <Field label="Email"><input className={inputCls} value={contact.email || ""} onChange={(e) => set("contact", "email", e.target.value)} /></Field>
          <Field label="Working Hours"><input className={inputCls} value={contact.hours || ""} onChange={(e) => set("contact", "hours", e.target.value)} /></Field>
        </div>
        <Field label="Address"><input className={inputCls} value={contact.address || ""} onChange={(e) => set("contact", "address", e.target.value)} /></Field>
        <Field label="Google Maps Embed URL"><input className={inputCls} value={contact.map_embed || ""} onChange={(e) => set("contact", "map_embed", e.target.value)} /></Field>
      </Panel>

      <Panel title="Payment Details">
        <Field label="UPI Payment QR Code"><SingleImageUploader path={payment.qr_path} onChange={(p) => set("payment", "qr_path", p)} label="Upload QR code" /></Field>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          <Field label="Account Name"><input className={inputCls} value={payment.account_name || ""} onChange={(e) => set("payment", "account_name", e.target.value)} /></Field>
          <Field label="Bank Name"><input className={inputCls} value={payment.bank_name || ""} onChange={(e) => set("payment", "bank_name", e.target.value)} /></Field>
          <Field label="Account Number"><input className={inputCls} value={payment.account_no || ""} onChange={(e) => set("payment", "account_no", e.target.value)} /></Field>
          <Field label="IFSC"><input className={inputCls} value={payment.ifsc || ""} onChange={(e) => set("payment", "ifsc", e.target.value)} /></Field>
          <Field label="Branch"><input className={inputCls} value={payment.branch || ""} onChange={(e) => set("payment", "branch", e.target.value)} /></Field>
        </div>
        <Field label="Payment Note"><textarea rows={2} className={inputCls} value={payment.fees_note || ""} onChange={(e) => set("payment", "fees_note", e.target.value)} /></Field>
      </Panel>

      <div className="sticky bottom-4"><Btn onClick={save} data-testid="save-settings">Save All Settings</Btn></div>
    </div>
  );
}
